import CheckboxGroupControl, { CheckboxGroupControlProps } from 'common/forms/CheckboxGroupControl';
import SelectControl, { SelectControlProps } from 'common/forms/SelectControl';
import { useMemo } from 'react';
import ServiceDetail from './ServiceDetail';

type CommonProps = SelectControlProps | CheckboxGroupControlProps;

export type ServiceListProps = CommonProps & {
  omitAllowed?: string[];
  onlyAllowed?: string[];
  variant?: 'multiple' | 'single';
  notFoundText?: string;
  isLoading?: boolean;
  sortAlphabetically?: boolean;
};

const ServiceList = ({
  variant = 'multiple',
  isLoading,
  omitAllowed = [],
  onlyAllowed = [],
  options,
  ...props
}: ServiceListProps) => {
  const filteredOptions = useMemo(() => {
    if (onlyAllowed && onlyAllowed?.length > 0) {
      return options.filter((option) => onlyAllowed?.includes(option.value));
    }
    if (omitAllowed && omitAllowed?.length > 0) {
      return options.filter((option) => !omitAllowed?.includes(option.value));
    }
    return options;
  }, [omitAllowed, onlyAllowed, options]);

  return variant === 'multiple' ? (
    <CheckboxGroupControl options={filteredOptions} {...props} renderComponent={ServiceDetail} />
  ) : (
    <SelectControl isLoading={isLoading} options={filteredOptions} {...props} isArrayValue />
  );
};

export default ServiceList;
